<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6">
        <v-col>
          <v-text-field
            v-model="customText"
            density="compact"
            variant="outlined"
          ></v-text-field>
          <v-btn color="primary" @click="renderSVG()">Render</v-btn>
        </v-col>
      </v-col>
      <v-col cols="12" sm="6">
        <CanvasView
          :renderText="customText"
          :renderTextFlag="renderTextFlag"
          @updateFlag="renderTextFlag = false"
        ></CanvasView>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import CanvasView from "@/components/session/CanvasView.vue";

export default {
  name: "SessionItemSvgPage",
  components: {
    CanvasView,
  },
  data: () => ({
    customText: "test",
    renderTextFlag: false,
  }),
  methods: {
    renderSVG() {
      this.renderTextFlag = true;
      //     let svgCode = this.productFabric.canvas.toSVG({
      //     width: (this.canvasWidth * 72) / fabric.DPI + "pt",
      //     height: (this.canvasHeight * 72) / fabric.DPI + "pt",
      //     viewBox: {
      //       x: 0,
      //       y: 0,
      //       width: this.canvasWidth,
      //       height: this.canvasHeight,
      //     },
      //   });
    },
  },
  mounted() {},
};
</script>
